import { useEffect, useState } from "react";
import Pagination from "../../Components/Pagination";
import UniversityWebTableRow from "./CampusTableRow";
import { Campus_Table_Model } from "../../Models/CampusModel";
function CampusTable({
  CampusLists,
  LOADING,
  CampusLists_Get_Req,
  handleDeleteCampus,
  handleEditCampusData,
  setCampusLists,
}) {
  const [UniversityPaginationTable, setUniversityPaginationTable] =
    useState(CampusLists);

  const [Page_data, setPage_data] = useState(10);

  const University_Table_Set = (page = 10) => {
    let New_data = [];
    for (let i = 0; i < CampusLists?.length; i++) {
      New_data.push(CampusLists[i]);
      if (i === page - 1) {
        break;
      }
    }
    setUniversityPaginationTable(New_data);
    setPage_data(page);
  };

  const SetPaginate_Page = (page) => {
    let New_data = [];
    for (let i = Page_data * (page - 1); i < CampusLists?.length; i++) {
      New_data.push(CampusLists[i]);
      if (New_data?.length === Page_data) {
        break;
      }
    }
    setUniversityPaginationTable(New_data);
  };

  useEffect(() => {
    University_Table_Set();
  }, [LOADING, CampusLists]);

  return (
    <div className="col-md-9 col-lg-10">
      <div className="coctacts-table">
        <div className="table-responsive custom-scroll-right-bottum">
          <table className="table table-condensed ">
            <thead className="t-head-th-bg">
              <tr>
              
                {Campus_Table_Model?.map((el, i) => (
                  <th className="t-head-fixed" key={i}>
                    {el}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="table-bordered">
              {UniversityPaginationTable?.map((el) => (
                <UniversityWebTableRow
                  key={el.Id}
                  {...el}
                  setCampusLists={setCampusLists}
                  handleEditCampusData={handleEditCampusData}
                  handleDeleteCampus={handleDeleteCampus}
                />
              ))}
            </tbody>
          </table>
        </div>
        <div className="Pagination">
          <Pagination
            SetPaginate_Page={SetPaginate_Page}
            PaginationTable={Page_data}
            UniversityTable_Set={University_Table_Set}
            Total_Records={CampusLists?.length}
          />
        </div>
      </div>
    </div>
  );
}

export default CampusTable;
